export type BrowseTaxonomies = {
  orderPageViewed: {
    currentPath?: string
    storeId?: string
    websiteId?: string
    websiteUrl?: string
    menulayoutDesign?: string
    productCardDesign?: string
    menuId?: string
    userId?: string
    countryCode?: string
  }
  addressSubmitted: {
    selectionType?: string
    isPinAdjusted?: boolean
    deliveryType?: string
    isAddressCoverage?: boolean
    isStoreOpen?: boolean
    errorMessage?: string
    actionLocation?: string
    menuId?: string
    currentPath?: string
    storeId?: string
    websiteId?: string
    websiteUrl?: string
    userId?: string
    countryCode?: string
  }
  authSuccessful: {
    currentPath?: string
    storeId?: string
    websiteId?: string
    websiteUrl?: string
    userId?: string
    countryCode?: string
  }
  productSelected: {
    categoryId?: string
    categoryName?: string
    productName?: string
    menuId?: string
    currentPath?: string
    storeId?: string
    websiteId?: string
    websiteUrl?: string
    userId?: string
    countryCode?: string
  }
}

export const BROWSE_EVENTS = Object.freeze({
  orderPageViewed: 'order-page-viewed',
  addressSubmitted: 'address-submitted',
  authSuccessful: 'auth-successful',
  productSelected: 'product-selected'
})
